<div>
    <div class="info-title" *ngIf="providerInfo.InfoMessage">
        <h2 class="break-word">{{providerInfo.Name}}</h2>
        <h6 class="provider-info-text">{{providerInfo.InfoMessage.TEXT}}
            <a [href]="providerInfo.InfoMessage.URL" target="_blank" class="provider-info-link">{{providerInfo.InfoMessage.URLText}}</a>
        </h6>
    </div>
    <div class="title" *ngIf="!providerInfo.InfoMessage">
        <h2>{{providerInfo.Name}}</h2>
    </div>
</div>